import { render, staticRenderFns } from "./editScore.vue?vue&type=template&id=55565882&scoped=true"
import script from "./editScore.vue?vue&type=script&lang=js"
export * from "./editScore.vue?vue&type=script&lang=js"
import style0 from "./editScore.vue?vue&type=style&index=0&id=55565882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55565882",
  null
  
)

export default component.exports